import { apiClient } from "./client";

/**
 * Gli ordini OdA/OdV come entità proprie (issue #211, PR A). Per ora solo la
 * ricerca per numero, usata dal riquadro «Riferimenti Odoo»: chi scrive un
 * numero che esiste già sta per collegare l'attività a un ordine esistente, e
 * deve saperlo prima di salvare. Solo admin e staff, come il riquadro.
 */

export type TipoOrdine = "oda" | "odv";

export interface OrdineTrovato {
  id: string;
  tipo: TipoOrdine;
  numero: string;
  fattura_registrata: boolean;
  fattura_registrata_at: string | null;
  /** Solo OdV; sempre `null` sugli OdA. */
  in_garanzia: boolean | null;
  /** Quante attività copre oggi. */
  attivita: number;
}

export async function cercaOrdine(tipo: TipoOrdine, numero: string): Promise<OrdineTrovato | null> {
  const { data } = await apiClient.get<{ ordine: OrdineTrovato | null }>("/ordini-odoo/cerca", {
    params: { tipo, numero },
  });
  return data.ordine;
}
